<template>
<div class="block-gap" style="display: flex;height: 100%;">
  <y-spacer class="flex-column block-gap" style="overflow: auto;">
    <y-spacer>
      <!-- 用户增量 -->
      <user-growth></user-growth>
    </y-spacer>
    <!-- 下载数据 -->
    <download-data></download-data>
  </y-spacer>
  <div style="width: 40%;" class="flex-column block-gap">
    <!--用户单位-->
    <word-cloud-chart style="height: 30%"></word-cloud-chart>
    <!--来源渠道-->
    <source-channel style="height: max-content;"></source-channel>
    <y-spacer>
      <!--新增用户-->
      <recent-user></recent-user>
    </y-spacer>
  </div>
</div>
</template>

<script>
import UserGrowth from "@/pages/board/components/UserGrowth/UserGrowth.vue";
import DownloadData from "@/pages/board/components/DownloadData/DownloadData.vue";
import WordCloudChart from "@/components/common/WordCloudChart/WordCloudChart.vue";
import SourceChannel from "@/pages/board/components/SourceChannel/SourceChannel.vue";
import RecentUser from "@/pages/board/components/RecentUser/RecentUser.vue";

export default {
  name: "board",
  components: {RecentUser, SourceChannel, WordCloudChart, DownloadData, UserGrowth}
}
</script>

<style lang="less" scoped>
.block-gap{
  gap: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/board/index.vue